'Currency'.datatype()
'currencyCode'.field({key: true})
'exchangeRate'.field({numeric: true, minDecimals: 4, caption: "Exchange Rate (Local amount times this equals Foreign amount)"})
